/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseIconAsset } from '../models/api-response-icon-asset';
import { ApiResponsePagedResultIconAsset } from '../models/api-response-paged-result-icon-asset';
import { createIconAsset } from '../fn/icon-asset-api/create-icon-asset';
import { CreateIconAsset$Params } from '../fn/icon-asset-api/create-icon-asset';
import { deleteIconAsset } from '../fn/icon-asset-api/delete-icon-asset';
import { DeleteIconAsset$Params } from '../fn/icon-asset-api/delete-icon-asset';
import { getListIconAsset } from '../fn/icon-asset-api/get-list-icon-asset';
import { GetListIconAsset$Params } from '../fn/icon-asset-api/get-list-icon-asset';
import { IconAsset } from '../models/icon-asset';
import { updateIconAsset } from '../fn/icon-asset-api/update-icon-asset';
import { UpdateIconAsset$Params } from '../fn/icon-asset-api/update-icon-asset';

@Injectable({ providedIn: 'root' })
export class IconAssetApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateIconAsset()` */
  static readonly UpdateIconAssetPath = '/v1/api/admin-ui/icon-asset/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateIconAsset()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateIconAsset$Response(params: UpdateIconAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseIconAsset>> {
    return updateIconAsset(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateIconAsset$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateIconAsset(params: UpdateIconAsset$Params, context?: HttpContext): Observable<ApiResponseIconAsset> {
    return this.updateIconAsset$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseIconAsset>): ApiResponseIconAsset => r.body)
    );
  }

  /** Path part for operation `getListIconAsset()` */
  static readonly GetListIconAssetPath = '/v1/api/admin-ui/icon-asset/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListIconAsset()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getListIconAsset$Response(params: GetListIconAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultIconAsset>> {
    return getListIconAsset(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getListIconAsset$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getListIconAsset(params: GetListIconAsset$Params, context?: HttpContext): Observable<ApiResponsePagedResultIconAsset> {
    return this.getListIconAsset$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultIconAsset>): ApiResponsePagedResultIconAsset => r.body)
    );
  }

  /** Path part for operation `createIconAsset()` */
  static readonly CreateIconAssetPath = '/v1/api/admin-ui/icon-asset/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createIconAsset()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createIconAsset$Response(params: CreateIconAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseIconAsset>> {
    return createIconAsset(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createIconAsset$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createIconAsset(params: CreateIconAsset$Params, context?: HttpContext): Observable<ApiResponseIconAsset> {
    return this.createIconAsset$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseIconAsset>): ApiResponseIconAsset => r.body)
    );
  }

  /** Path part for operation `deleteIconAsset()` */
  static readonly DeleteIconAssetPath = '/v1/api/admin-ui/icon-asset/delete/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteIconAsset()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteIconAsset$Response(params: DeleteIconAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<IconAsset>> {
    return deleteIconAsset(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteIconAsset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteIconAsset(params: DeleteIconAsset$Params, context?: HttpContext): Observable<IconAsset> {
    return this.deleteIconAsset$Response(params, context).pipe(
      map((r: StrictHttpResponse<IconAsset>): IconAsset => r.body)
    );
  }

}
